export enum OrderExpiryType {
  GTC,
  GTT,
  DAY,
}

export namespace OrderExpiryType {
  let elements = [OrderExpiryType.GTC, OrderExpiryType.GTT, OrderExpiryType.DAY];
  let alias = "com.bcdfx.model.OrderExpiryType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
